import React from 'react';
import Layout from '../layouts/three';
import UpcomingTournaments from '../tournaments/upcoming';
import Information from '../information/partials/home';
import ContactForm from '../contact/form';
import Rankings from '../rankings/partials/home';
import Sponsors from '../sponsors/index';
import { preload } from '../../helpers';

// August 6th: refactored for responsiveness
class Home extends React.Component {
    componentDidMount() {
        preload(this.props);
    }
    render() {
        return (
            <Layout nbs="home">
                <section>
                    <div className="w3-white" id="tournaments">
                        <UpcomingTournaments className="padding-top-double padding-bottom-double" {...this.props} />
                    </div>
                    <div className="w3-black" id="rankings">
                        <Rankings className="" />
                    </div>
                    <div className="w3-white" id="information">
                        <Information className="padding-top-double padding-bottom-double" />
                    </div>
                    <div className="w3-black" id="contact">
                        <ContactForm className="padding-top-double padding-bottom-double"  {...this.props} />
                    </div>
                    <div className="bg-blackish" id="sponsors">
                        <Sponsors {...this.props} />
                    </div>
                </section>
            </Layout>
        )
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/index.js